module.exports = __webpack_public_path__ + "img/system_3.6bd573ba.jpg";